<template>
  <div id="cxjl">
    <div v-for="item in list">
      <p><b>时间：</b> {{item.TIME}} </p>
      <p><b>类别：</b> {{item.TYPE}} </p>
      <p><b>实施机关：</b> {{item.SSJG}} </p>
      <p><b>文号：</b> {{item.WH}} </p>
      <p><b>情况简介（200字以内）：</b> {{item.QKJJ}} </p>
      <div v-if="list.length > 1" class="line"></div>
      <div class="margin-b"></div>
    </div>
  </div>
</template>

<script>
  import ajax from '@/common/ajax/ajax'

  export default {
    name: 'cxjl',
    data () {
      return {
        list: [{xm: '数据读取中'}]
      }
    },
    mounted () {
      this.getData()
    },
    methods: {
      getData () {
        ajax.getCXJL().then(
          data => {
            this.list = data
          }
        )
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// cxjl.vue?0008eeaa